import { cn } from '@rocco/utils/cn';

/**
 * An avatar-like component that displays a thumbnail image. This is used instead
 * of the `ParticipantAvatar` component when the chat has a custom thumbnail image.
 * This should have the same size and style as the `ParticipantAvatar` component.
 * @see {@link ParticipantAvatar}
 */
export function ThumbnailAvatar({
    className,
    src,
}: {
    className?: string;
    src: string;
}) {
    return (
        <img
            className={cn(
                'aspect-square size-12 rounded-full bg-white object-cover transition-[width,height] duration-100 will-change-[width,height]',
                // Need to override normalize.css styles here.
                'border-solid',
                className
            )}
            src={src}
            alt="Chat thumbnail"
        />
    );
}
